import React from 'react';

import { observer } from 'mobx-react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from '@mui/material';

import { AppCampCollectionFragment } from '../../../generated/graphql';
import { FlexBetween } from '../../common/CommonDivs';
import { DeleteIcon, SavedIconText, WhiteIconButton } from '../../icons';
import { LabelSwitch } from '../../switch';
import { useUpdateCampCollection } from '../../../hooks/camps';

export const CampCollectionForm = observer(function CampCollectionForm({
  selectedItem,
  setSelectedItem,
  itemSingular,
  descriptionEnabled = false,
  priceEnabled = false,
  limitEnabled = false,
  genderEnabled = false,
}: {
  selectedItem: AppCampCollectionFragment;
  setSelectedItem: (item: any) => void;
  itemSingular: string;
  descriptionEnabled?: boolean;
  priceEnabled?: boolean;
  limitEnabled?: boolean;
  genderEnabled?: boolean;
}) {
  const {
    state,
    hasSaved,
    handleChange,
    handleSave,
    handleSwitchChange,
    onKeyDown,
    handleBlur,
    deleteItem,
  } = useUpdateCampCollection({ item: selectedItem });

  const deleteCampCollectionItem = () => {
    deleteItem()
      .then(() => setSelectedItem(null))
      .catch();
  };

  if (!state) {
    return <div>Ingen vald {itemSingular}</div>;
  }
  const { name, description, price, deleted, limit, filter } = state;


  const handleGenderChange = (value) => {
    console.log('Selected value:', value);

    let newState = handleChange({
      target: {
        name: 'filter',
        value: value,
      },
    });

    handleSave(newState);

  }

  return (
    <div>
      <TextField
        margin="normal"
        required={true}
        fullWidth
        id={'name'}
        name={'name'}
        label={`Namn på ${itemSingular}`}
        value={name || ''}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        onBlur={handleBlur}
      />
      {descriptionEnabled && (
        <TextField
          margin="normal"
          fullWidth
          id={'description'}
          name={'description'}
          label={`Extra info i anmälningsformuläret`}
          value={description || ''}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          onBlur={handleBlur}
        />
      )}
      {limitEnabled && (
        <TextField
          margin="normal"
          fullWidth
          id={'limit'}
          name={'limit'}
          label={`Begränsande antal`}
          value={limit || 0}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          onBlur={handleBlur}
        />
      )}
      {genderEnabled && (

        <>
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">Visa fältet enbart för</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel value="Tjej" control={<Radio />}
                checked={filter === 'Tjej'}
                onClick={() => handleGenderChange('Tjej')}
                label="Tjejer" />
              <FormControlLabel value="Kille"
                checked={filter === 'Kille'}
                control={<Radio />}
                onClick={() => handleGenderChange('Kille')}
                label="Killar" />
              <FormControlLabel value=""
                checked={filter != 'Tjej' && filter != 'Kille'}
                onClick={() => handleGenderChange('Alla')}
                control={<Radio />}
                label="Alla" />

            </RadioGroup>
          </FormControl>

        </>
      )}
      {priceEnabled && (
        <TextField
          margin="normal"
          fullWidth
          id={'price'}
          name={'price'}
          label={`Pris`}
          value={price || 0}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          onBlur={handleBlur}
        />
      )}
      <LabelSwitch
        label={'Är aktiv i Anmälningsformuläret'}
        // note this is saved as deleted in the database
        // check useUpdateCollection:58
        name={'enabled'}
        value={!deleted}
        onChange={handleSwitchChange}
      />
      <br />
      <br />
      <FlexBetween>
        <SavedIconText visible={hasSaved} />

        <WhiteIconButton
          icon={<DeleteIcon />}
          title={`Radera ${itemSingular}`}
          onClick={deleteCampCollectionItem}
        />
      </FlexBetween>
    </div>
  );
});
